import { QuoteDestinationsResponse } from '@packages/types';

import { openApiInstances } from './openApis';

export const getQuoteDestinations = (args?: { isTravelSearch?: boolean }) => {
  const path = args?.isTravelSearch ? '/destinations?isTravelSearch=true' : '/destinations';
  return openApiInstances.Quote.get<QuoteDestinationsResponse>(path);
};
